// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"983371f4b452587d","5285":"13113d6eba0b8a1a"}[chunkId] + ".css";
};